import React from "react";

const latitude = 54.689027;
const longitude = 8.570583;

function MapContainer() {
    const query = `${latitude},${longitude}`;

    return (
        <div style={{width: "100%", marginTop: "1rem"}}>
            <iframe
                title="Google Maps – Strandperle Sandwall"
                src={`https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=16&output=embed`}
                width="100%"
                height="300"
                style={{border: 0, display: "block"}}
                loading="lazy"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
            />
            <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`}
                target="_blank"
                rel="noreferrer"
            >
                Größere Karte in Google Maps öffnen
            </a>
        </div>
    );
}

export default MapContainer;
